<template>
    <div class="pt-2">
        <div class="pb-12 mb-10 border-b border-gray-500">
            <shared-with-me
                :broker="broker"
                :shared_with_me="shared_with_me"
            />
        </div>

        <div class="pb-8">
            <shared-with-others
                :broker="broker"
                :shared_with_others="shared_with_others"
            />
        </div>
    </div>
</template>

<script>
import SharedWithMe from './shared-with-me.vue';
import SharedWithOthers from './shared-with-others.vue';

export default {
    components: {
        SharedWithMe,
        SharedWithOthers,
    },

    props: {
        closed: { default: true },
        broker: {},
        shared_with_me: {},
        shared_with_others: {},
    },
}
</script>
